import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import User from '_class/User';
import { getUserInfo, getMentorSections, getUserRoles } from "actions/user";
import { setPageTitle } from "actions/header";
import UserRoles from "./Partials/UserRoles";
import Subjects from "./Partials/Subjects";
import { Spinner } from 'UI';
import { Flex, Skeleton, getActiveLanguage, Block, Tabs, Tab, translate } from '@haldor/ui';
import SectionList from "components/List/SectionList";

var Staff = /*#__PURE__*/function (_Component) {
  _inherits(Staff, _Component);

  var _super = _createSuper(Staff);

  function Staff(props) {
    var _this;

    _classCallCheck(this, Staff);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var userId = null;

      if (_this.props.match != null && _this.props.match.params.userId != null) {
        userId = _this.props.match.params.userId;
      } else if (_this.props.userId != null) {
        userId = _this.props.userId;
      } else {
        userId = _this.props.currentStaff.id;
      }

      if (_this.props.currentStaff == null) {
        var userSchoolAdmin = _this.isCurrentUserSchoolAdmin();

        _this.props.getUserInfo(userId, "default").then(function () {
          var staffIsMentor = _this.isCurrentStaffMentor();

          _this.setState({
            loading: false,
            userSchoolAdmin: userSchoolAdmin,
            staffIsMentor: staffIsMentor
          });

          _this.props.setPageTitle(_this.props.currentStaff.firstName + " " + _this.props.currentStaff.lastName);
        });
      } else {
        var _userSchoolAdmin = _this.isCurrentUserSchoolAdmin();

        var staffIsMentor = _this.isCurrentStaffMentor();

        _this.setState({
          loading: false,
          userSchoolAdmin: _userSchoolAdmin,
          staffIsMentor: staffIsMentor
        });

        _this.props.setPageTitle(_this.props.currentStaff.firstName + " " + _this.props.currentStaff.lastName);
      }

      _this.props.getUserRoles(userId).then(function () {
        _this.setState({
          loadingRoles: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isCurrentUserSchoolAdmin", function () {
      if (_this.props.currentUser.userRoles != null && _this.props.currentUser.userRoles.length > 0) {
        var schoolAdministrator = _this.props.currentUser.userRoles.find(function (role) {
          return role.toUpperCase() == "SCHOOL_ADMINISTRATOR" || "SYSADMIN";
        });

        if (schoolAdministrator != null) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isCurrentStaffMentor", function () {
      if (_this.props.currentStaff == null) {
        return false;
      }

      if (_this.props.currentStaff.userRoles != null && _this.props.currentStaff.userRoles.length > 0) {
        var mentor = _this.props.currentStaff.userRoles.find(function (role) {
          return role.toUpperCase() == "MENTOR";
        });

        if (mentor != null) {
          return true;
        }
      }

      return false;
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      loading: true,
      loadingGroups: true,
      loadingRoles: true,
      userSchoolAdmin: false,
      staffIsMentor: false
    };
    return _this;
  }

  _createClass(Staff, [{
    key: "render",
    value: function render() {
      var user = new User(this.props.currentUser);

      if (this.state.loading || this.props.currentStaff == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "staff-card"
        }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 225
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null))))));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "staff-card"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('e-mail')), this.props.currentStaff.email != null ? this.props.currentStaff.email : null), /*#__PURE__*/React.createElement(Tabs, null, this.state.userSchoolAdmin || this.state.staffIsMentor ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Groups'),
        route: "mentor"
      }, this.state.userSchoolAdmin ? /*#__PURE__*/React.createElement(SectionList, {
        userId: this.props.currentStaff.userId
      }) : null) : null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('roles'),
        route: "roles"
      }, this.state.loadingRoles ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(UserRoles, {
        currentStaff: this.props.currentStaff
      })), user.isAdministrator() ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('subjects'),
        route: "subjects"
      }, /*#__PURE__*/React.createElement(Subjects, {
        userId: this.props.currentStaff.userId
      })) : null));
    }
  }]);

  return Staff;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    currentUser: state.user.currentUser,
    currentStaff: state.user.info.find(function (u) {
      return u.userId == ownProps.match.params.userId;
    })
  };
}

export default connect(mapStateToProps, {
  getUserInfo: getUserInfo,
  setPageTitle: setPageTitle,
  getMentorSections: getMentorSections,
  getUserRoles: getUserRoles
})(Staff);